<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div class="recent-grid">

    <div class="projects">
        <div class="card">
            <div class="card-body">

                <div class="">
                    <p class="titulo-card-amarillo">Datos del Jardín Infantil</p>

                    <table class="table-info">
                        <tr>
                            <td>
                                <p class="table-row-title">Código:</p>
                            </td>
                            <td>{{uniEducativa.rbd}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Nombre:</p>
                            </td>
                            <td>{{uniEducativa.nombreJardin}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Programa:</p>
                            </td>
                            <td>{{uniEducativa.programa}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Modalidad:</p>
                            </td>
                            <td>{{uniEducativa.modalidad}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Teléfono:</p>
                            </td>
                            <td>{{uniEducativa.telefono}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Dirección:</p>
                            </td>
                            <td>{{uniEducativa.direccion}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Comuna:</p>
                            </td>
                            <td>{{uniEducativa.comuna}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Región:</p>
                            </td>
                            <td>{{uniEducativa.region}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="projects">

        <div class="card">


            <div class="card-body">
                <div>
                    <p class="titulo-card-amarillo">Datos de la Directora o Encargada</p>
                    <table class="table-info">
                        <tr>
                            <td>
                                <p class="table-row-title">Nombre:</p>
                            </td>
                            <td>{{datosDirec.nombreDirectora}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Correo Institucional:</p>
                            </td>
                            <td>{{datosDirec.correo}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Correo Personal (opcional):</p>
                            </td>
                            <td>{{datosDirec.correoParticular}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Teléfono Personal (opcional):</p>
                            </td>
                            <td>{{datosDirec.telefono}}</td>
                        </tr>
                    </table>
                    <br>

                    <!--<div class="special-padding">
                        <h6>¡Atención!</h6>
                        <p> Si los datos en esta sección no coinciden con los de su Unidad Educativa, escribanos un mensaje indicando los cambios a través del siguiente enlace:</p>
                        <button type="button" class="btn btn-light btn-send" (click)="abrirModalConsulta()">Solicitar Cambios</button>
                    </div>-->

                </div>
            </div>
        </div>
    </div>


</div>

<div class="row">
    <div class="col-12 team-special-margin">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6">
                        <p class="titulo-card-amarillo">Equipo Pedagógico</p>
                    </div>
                    <div class="col-sm-6 team-special-padding" style="text-align: right;">
                        <button type="button" class="btn btn-light btn-send" (click)="nuevoMiembro()"><i class="fas fa-plus"></i> Agregar Integrante</button>
                    </div>

                </div>

                <table class="table-info">
                    <thead>
                        <tr>
                            <th>
                                <p class="table-row-title">Rut</p>
                            </th>
                            <th>
                                <p class="table-row-title">Nombre</p>
                            </th>
                            <th>
                                <p class="table-row-title">Apellidos</p>
                            </th>
                            <th>
                                <p class="table-row-title">Correo institucional</p>
                            </th>
                            <th>
                                <p class="table-row-title">Teléfono</p>
                            </th>
                            <th>
                                <p class="table-row-title">Cargo</p>
                            </th>
                            <th>
                                <p class="table-row-title">Acciones</p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let cuenta of this.responseEquipoPedagogico.payload;let impar = odd;let par = even;" [ngClass]="{azul:par,'table-tr-shadow':impar}">
                            <td>{{cuenta.rut}}</td>
                            <td>{{cuenta.nombres}}</td>
                            <td>{{cuenta.apellido}}</td>
                            <td>{{cuenta.correoParticular}}</td>
                            <td>{{cuenta.telefono}}</td>
                            <td>{{cuenta.estamento.descripcionLarga}}</td>
                            <td>
                                <button class="btn-editar" (click)="editarMiembro(cuenta)">
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                                <button class="btn-eliminar" (click)="eliminarMiembro(cuenta)">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>

<ng-template #modalSolicitarCambios let-modal>
    <div class="modal-header" style="padding: 0px 50px;" width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Solicitud de ajustes en información</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px 50px;" width="100%">

        <p style="margin-top: 20px;margin-bottom: 10px;">
            Indique a continuación si existe información errada y datos que no coinciden con los de su Unidad Educativa:
        </p>

        <textarea class="text-area-consulta" name="consulta" placeholder="MENSAJE" [(ngModel)]="consulta" #introduccion='ngModel'></textarea>
        <button type="button" class="btn btn-light btn-send mb-4" (click)="enviar()"> Enviar</button>
    </div>
</ng-template>




<ngx-spinner></ngx-spinner>